import { render, staticRenderFns } from "./_form-table-list-price-item.vue?vue&type=template&id=356fa798"
import script from "./_form-table-list-price-item.vue?vue&type=script&lang=js"
export * from "./_form-table-list-price-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports